import * as React from 'react';

import SystemMessage from './SystemMessage';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  text: string
};

class SystemChatMessageBrandRejected extends SystemMessage<Props> {
  render(): React.ReactNode {
    const { text } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon('brief-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            <div className="messages-system-message__heading">
              {__t('system_message.brand_rejected')}
            </div>
            <div
              className="messages-system-message__paragraph"
              dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(text) }}
            />
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageBrandRejected;
